import { defineManifest } from "@crialume/sdk";
import { ScissorsIcon } from "@crialume/ui/icons";

export default defineManifest({
  id: "moldes",
  version: "0.1.0",
  meta: {
    name: "Personalizar",
    description: "Moldes prontos para personalizar",
    icon: ScissorsIcon,
    category: "core",
    order: 2,
  },
  requirements: {
    permissions: ["molds.customize"],
  },
  nav: [{ label: "Personalizar", path: "", icon: ScissorsIcon }],
  fullscreenRoutes: [
    "projeto/:projectId",
    "projeto/:projectId/imprimir",
    "projeto/:projectId/comprar",
  ],
  loader: () => import("./module"),
});
